import { keyframes } from '@emotion/core'

export default function animation(name) {
  // returns emotion keyframes by animation name
  let frames = keyframes``

  if (name === 'grow-from-left') {
    frames = keyframes`
    0% { width: 0; }
   `
  } else if (name === 'bounce') {
    frames = keyframes`
    from, 20%, 53%, 80%, to { transform: translate3d(0,0,0); }
    40%, 43% { transform: translate3d(0, -30px, 0); }
    70% { transform: translate3d(0, -15px, 0); }
    90% { transform: translate3d(0,-4px,0); }
    `
  } else if (name === 'flip') {
    frames = keyframes`
    from, 20%, 53%, 80%, to { transform: translate3d(0,0,0); }
    40%, 43% { transform: translate3d(0, -30px, 0); }
    70% { transform: translate3d(0, -15px, 0); }
    90% { transform: translate3d(0,-4px,0); }
    `
  } else if (name === 'fade-in') {
    frames = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
    `
  } else if (name === 'fade-out') {
    frames = keyframes`
    0% { opacity: 1; }
    100% { opacity: 0; pointer-events: none; }
    `
  } else if (name === 'slit-in') {
    frames = keyframes`
    0% { transform: translateZ(-800px) rotateY(90deg); opacity: 0; }
    60% { transform: translateZ(-160px) rotateY(87deg); opacity: 1; }
    100% { transform: translateZ(0) rotateY(0); }
    `
  } else if (name === 'slit-out') {
    frames = keyframes`
    0% { transform: translateZ(0) rotateY(0); }
    40% { transform: translateZ(-160px) rotateY(87deg); opacity: 1; }
    100% { transform: translateZ(-800px) rotateY(90deg); opacity: 0; pointer-events: none; }
    `
  } else if (name === 'slide-in-bottom') {
    // animation: slide-in-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    frames = keyframes`
    0% { transform: translateY(1000px); opacity: 0; }
    20% { opacity: 1; }
    100% { transform: translateY(0); opacity: 1; }
    `
  } else if (name === 'slide-out-bottom') {
    // animation: slide-out-bottom 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
    frames = keyframes`
    0% { transform: translateY(0); opacity: 1; }
    80% { opacity: 1; }
    100% { transform: translateY(1000px); opacity: 0; }
    `
  } else if (name === 'slide-in-right') {
    // animation: slide-in-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    frames = keyframes`
      0% {
      transform: translateX(1000px);
      opacity: 0;
      }
      20% {
        opacity: 1;
      }
      100% {
      transform: translateX(0);
      opacity: 1;
      }
    `
  } else if (name === 'slide-out-right') {
    // animation: slide-out-right 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
    frames = keyframes`
      0% {
      transform: translateX(0);
      opacity: 1;
      }
      80% {
        opacity: 1;
      }
      100% {
      transform: translateX(1000px);
      opacity: 0;
      }
    `
  } else if (name === 'flip-in-horizontal') {
    // animation: flip-in-hor-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    frames = keyframes`
      0% {
      transform: rotateX(-80deg);
      opacity: 0;
      }
      100% {
      transform: rotateX(0);
      opacity: 1;
      }
    `
  } else if (name === 'flip-out-horizontal') {
    // animation: flip-out-hor-bottom 0.45s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
    frames = keyframes`
      0% {
      transform: rotateX(0);
      opacity: 1;
      }
      100% {
      transform: rotateX(-70deg);
      opacity: 0;
      }
    `
  } else if (name === 'flip-right') {
    frames = keyframes`
    0% {
                transform: rotateY(0);
      }
      100% {
                transform: rotateY(180deg);
      }
    }
    `
  } else if (name === 'flip-left') {
    frames = keyframes`
        0% {
                  transform: rotateY(0);
        }
        100% {
                  transform: rotateY(-180deg);
        }
      }
    `
  } else if (name === 'spin') {
    frames = keyframes`
      to {
        transform: ArrowRotate(360deg)
      }
    `
  } else if (name === 'puff-in') {
    // animation: puff-in 400ms cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
    frames = keyframes`
      0% {
        transform: scaleX(2);
        filter: blur(2px);
        opacity: 0;
      }
      100% {
        transform: scaleX(1);
        filter: blur(0px);
        opacity: 1;
      }
    `
  } else if (name === 'puff-out') {
    // animation: puff-out 600ms cubic-bezier(0.165, 0.840, 0.440, 1.000) both;
    frames = keyframes`
      0% {
        transform: scaleX(1);
        filter: blur(0px);
        opacity: 1;
      }
      100% {
        transform: scaleX(2);
        filter: blur(2px);
        opacity: 0;
      }
    `
  } else if (name === 'fadein-up') {
    frames = keyframes`
      0% {
        opacity: 0;
        transform: translate3d(0, 100%, 0);
      }
      100% {
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
    `
  } else if (name === 'fadein-down') {
    frames = keyframes`
      0% {
        opacity: 0;
        transform: translate3d(0, -100%, 0);
      }
      100% {
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
    `
  } else if (name === 'fadein-right') {
    frames = keyframes`
      0% {
        opacity: 0;
        transform: translate3d(100%, 0, 0);
      }
      100% {
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
    `
  } else if (name === 'fadein-left') {
    frames = keyframes`
      0% {
        opacity: 0;
        transform: translate3d(-100%, 0, 0);
      }
      100% {
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
    `
  } else if (name === 'zoomInDown') {
    frames = keyframes`
      from {
        opacity: 0;
        transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
      }

      60% {
        opacity: 1;
        transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
        animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
      }
    `
  }

  return frames
}
